// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2LMpE","col":"styles_col__3Jnbt","fulfillmentStatus":"styles_fulfillmentStatus__1wl9S","emailCol":"styles_emailCol__2wzmC"};